// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"636beb8b","701":"e8abc8da"}[chunkId] + ".chunk.js";
};